/* Zurbeco — utilidades comunes: sliders con puntos, filtros con pills y añadir al carrito */
(function () {
  'use strict';

  /* ---------- Slider con puntos ---------- */
  function initSlider(root) {
    const track = root.querySelector('[data-zb-track]');
    const dots = root.querySelector('[data-zb-dots]');
    if (!track || !dots || track.dataset.zbReady) return;
    track.dataset.zbReady = '1';

    const visible = () => [...track.children].filter((el) => !el.hidden);
    const pages = () => {
      const items = visible();
      if (!items.length) return 0;
      const per = Math.max(1, Math.round(track.clientWidth / items[0].getBoundingClientRect().width));
      return Math.max(1, items.length - per + 1);
    };

    function build() {
      const n = pages();
      dots.innerHTML = '';
      if (n <= 1) return;
      for (let i = 0; i < n; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir a la diapositiva ' + (i + 1));
        b.addEventListener('click', () => {
          track.scrollTo({ left: (track.scrollWidth - track.clientWidth) * (i / (n - 1)), behavior: 'smooth' });
        });
        dots.appendChild(b);
      }
      update();
    }

    function update() {
      const btns = dots.children;
      if (!btns.length) return;
      const max = track.scrollWidth - track.clientWidth;
      const idx = max <= 0 ? 0 : Math.round((track.scrollLeft / max) * (btns.length - 1));
      [...btns].forEach((b, i) => b.classList.toggle('is-active', i === idx));
    }

    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', build);
    root.zbRebuild = () => { track.scrollLeft = 0; build(); };
    build();
  }

  /* ---------- Filtros por pills ---------- */
  function initFilter(root) {
    const pills = root.querySelectorAll('[data-zb-filter]');
    if (!pills.length || root.dataset.zbFilterReady) return;
    root.dataset.zbFilterReady = '1';
    const apply = (value) => {
      pills.forEach((p) => p.classList.toggle('is-active', p.dataset.zbFilter === value));
      root.querySelectorAll('[data-zb-tags]').forEach((item) => {
        const tags = item.dataset.zbTags.split('|');
        item.hidden = !(value === '*' || tags.includes(value));
      });
      const slider = root.closest('[data-zb-slider]') || root.querySelector('[data-zb-slider]');
      if (slider && slider.zbRebuild) slider.zbRebuild();
    };
    pills.forEach((p) => p.addEventListener('click', () => apply(p.dataset.zbFilter)));
    const active = root.querySelector('[data-zb-filter].is-active') || pills[0];
    apply(active.dataset.zbFilter);
  }

  /* ---------- Añadir al carrito (usa el carrito lateral de Dawn si existe) ---------- */
  window.zbAddToCart = async function (variantId, quantity, button) {
    const drawer = document.querySelector('cart-drawer');
    const notification = document.querySelector('cart-notification');
    const target = drawer || notification;
    const body = { items: Array.isArray(variantId) ? variantId : [{ id: Number(variantId), quantity: Number(quantity) || 1 }] };
    if (target && target.getSectionsToRender) {
      body.sections = target.getSectionsToRender().map((s) => s.section || s.id);
      body.sections_url = window.location.pathname;
    }
    if (button) { button.disabled = true; button.classList.add('is-loading'); }
    try {
      const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || json.message || 'Error');
      if (target && target.renderContents && json.sections) {
        const item = (json.items && json.items[0]) || json;
        target.renderContents({ ...item, sections: json.sections });
        if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      if (window.zbGiftGuard) window.zbGiftGuard();
      return true;
    } catch (e) {
      alert(e.message || 'No se pudo añadir al carrito');
      return false;
    } finally {
      if (button) { button.disabled = false; button.classList.remove('is-loading'); }
    }
  };

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-zb-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-zb-filters]').forEach(initFilter);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  // Editor de temas
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  window.zbInit = initAll;
})();

/* Botón "Añadir" de las tarjetas */
document.addEventListener('click', function (e) {
  const b = e.target.closest('[data-zb-add]');
  if (!b || !window.zbAddToCart) return;
  e.preventDefault();
  window.zbAddToCart(b.dataset.zbAdd, 1, b).finally(function () { b.disabled = false; b.classList.remove('is-loading'); });
});

/* Flechas genéricas de carrusel: [data-zb-arrow="prev|next"] dentro de [data-zb-slider] */
document.addEventListener('click', function (e) {
  const a = e.target.closest('[data-zb-arrow]');
  if (!a) return;
  const root = a.closest('[data-zb-slider]');
  const track = root && root.querySelector('[data-zb-track]');
  if (!track) return;
  const step = track.clientWidth * 0.85 * (a.dataset.zbArrow === 'prev' ? -1 : 1);
  track.scrollBy({ left: step, behavior: 'smooth' });
});

/* Código de descuento en el carrito lateral */
(function () {
  async function refreshDrawer() {
    const drawer = document.querySelector('cart-drawer');
    const url = ((window.routes && window.routes.cart_url) || '/cart') + '?sections=cart-drawer,cart-icon-bubble';
    const json = await (await fetch(url)).json();
    const doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
    const fresh = doc.querySelector('#CartDrawer');
    const current = document.querySelector('#CartDrawer');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && json['cart-icon-bubble']) {
      const b = new DOMParser().parseFromString(json['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
    if (drawer) {
      const overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', () => drawer.close());
    }
  }
  window.zbRefreshDrawer = refreshDrawer;
  async function setDiscount(code, btn) {
    if (btn) btn.disabled = true;
    try {
      await fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      });
      await refreshDrawer();
    } finally { if (btn) btn.disabled = false; }
  }
  document.addEventListener('click', function (e) {
    const apply = e.target.closest('[data-zb-discount-apply]');
    if (apply) {
      const input = apply.closest('[data-zb-discount]').querySelector('[data-zb-discount-input]');
      const code = (input.value || '').trim();
      if (code) setDiscount(code, apply);
      return;
    }
    const remove = e.target.closest('[data-zb-discount-remove]');
    if (remove) setDiscount('', remove);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-zb-discount-input]')) {
      e.preventDefault();
      e.target.closest('[data-zb-discount]').querySelector('[data-zb-discount-apply]').click();
    }
  });
})();

/* Regalo del pack: si el cliente baja las unidades, el regalo se quita solo */
(function () {
  let busy = false;
  async function guard(cart) {
    if (busy) return;
    busy = true;
    try {
      if (!cart || !cart.items) cart = await (await fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js')).json();
      let changed = false;
      const given = {};
      for (const g of cart.items.filter((i) => i.original_price === 0 || (i.properties && i.properties._zb_gift))) {
        const props = g.properties || {};
        const forId = Number(props._zb_gift_for), min = Math.max(1, Number(props._zb_gift_min) || 1);
        const units = props._zb_gift ? cart.items.filter((i) => i.product_id === forId && i.original_price > 0).reduce((s, i) => s + i.quantity, 0) : 0;
        // Un regalo de cada tipo por pedido
        const allowed = Math.max(0, Math.min(1, Math.floor(units / min)) - (given[g.variant_id] || 0));
        given[g.variant_id] = (given[g.variant_id] || 0) + Math.min(g.quantity, allowed);
        if (g.quantity > allowed) {
          await fetch(((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: g.key, quantity: allowed }),
          });
          changed = true;
        }
      }
      // Si ya hay linternas suficientes y falta el regalo, se añade solo
      const cfg = window.zbGift;
      if (cfg && !cart.items.some((i) => i.variant_id === cfg.v)) {
        const units = cart.items.filter((i) => i.product_id === cfg.f && i.original_price > 0).reduce((s, i) => s + i.quantity, 0);
        if (units >= cfg.m) {
          await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: cfg.v, quantity: 1, properties: { _zb_gift: '1', _zb_gift_min: String(cfg.m), _zb_gift_for: String(cfg.f) } }] }),
          });
          changed = true;
        }
      }
      // Protección de envío: como mucho 1, y fuera si no queda nada que proteger
      const pv = window.zbProt;
      const pl = pv && cart.items.find((i) => i.variant_id === pv);
      if (pv && !pl && !(window.zbProtOut && window.zbProtOut()) && cart.items.some((i) => i.final_line_price > 0)) { await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: pv, quantity: 1 }] }) }); changed = true; } // Protección preseleccionada: se añade sola salvo que el cliente la quitara antes
      if (pl) {
        const want = cart.items.some((i) => i.variant_id !== pv && i.final_line_price > 0) ? 1 : 0;
        if (pl.quantity !== want) {
          await fetch(((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: pl.key, quantity: want }),
          });
          changed = true;
        }
      }
      if (changed) {
        if (!document.querySelector('cart-drawer')) location.reload();
        else if (window.zbRefreshDrawer) await window.zbRefreshDrawer();
      }
    } catch (e) { /* sin conexión: no hacemos nada */ } finally { busy = false; }
  }
  window.zbGiftGuard = guard;
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => guard(e && e.cartData));
  }
  if (/\/cart\/?$/.test(location.pathname) || document.querySelector('cart-drawer:not(.is-empty)')) guard();
})();

/* Protección de envío (interruptor del carrito) */
document.addEventListener('change', async function (e) {
  const t = e.target.closest('[data-zb-prot-toggle]');
  if (!t) return;
  const box = t.closest('[data-zb-prot]');
  const id = Number(box.dataset.zbProt);
  const on = t.checked;
  try { if (on) localStorage.removeItem('zb_prot_optout'); else localStorage.setItem('zb_prot_optout', '1'); } catch (err) {} // Recordar si el cliente la quita
  box.classList.toggle('is-on', on);
  t.disabled = true;
  const r = window.routes || {};
  try {
    await fetch(on ? (r.cart_add_url || '/cart/add') + '.js' : (r.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(on ? { items: [{ id: id, quantity: 1 }] } : { id: String(id), quantity: 0 }),
    });
  } catch (err) { /* sin conexión */ }
  if (/\/cart\/?$/.test(location.pathname) || !window.zbRefreshDrawer) location.reload();
  else await window.zbRefreshDrawer();
});
window.zbProtOut = function () { try { return localStorage.getItem('zb_prot_optout') === '1'; } catch (err) { return false; } };
/* La protección de envío viaja en la misma petición que el producto (sin retardo) */
(function () {
  var orig = window.zbAddToCart;
  if (!orig) return;
  window.zbAddToCart = function (variantId, quantity, button) {
    try {
      var pv = window.zbProt;
      var items = Array.isArray(variantId) ? variantId : [{ id: Number(variantId), quantity: Number(quantity) || 1 }];
      var yaEsta = !!document.querySelector('.zb-cx-prot.is-on');
      var laQuito = !!(window.zbProtOut && window.zbProtOut());
      if (pv && !yaEsta && !laQuito && !items.some(function (it) { return Number(it.id) === pv; })) {
        items.push({ id: pv, quantity: 1 });
      }
      return orig(items, quantity, button);
    } catch (err) {
      return orig(variantId, quantity, button);
    }
  };
})();